// extracted by mini-css-extract-plugin
module.exports = {"navMenu":"DesktopMenu_navMenu__TstTm","navItem":"DesktopMenu_navItem__LNqkn","navItemActive":"DesktopMenu_navItemActive__GawA3","navLink":"DesktopMenu_navLink__3g01b"};